/**
 * Only http(s) destinations are allowed to render as links, so a bad value in
 * the link data (e.g. a `javascript:` or `data:` URL) can never become a
 * clickable script-execution vector on a public page.
 */
export function isSafeHttpUrl(value: string): boolean {
  try {
    const url = new URL(value)
    return url.protocol === 'https:' || url.protocol === 'http:'
  } catch {
    return false
  }
}
